import { css } from 'styled-components';

export const Image = css`
  display: inline-block;
  height: auto;
  max-width: 100%;

  &[data-full-width='true'] {
    width: 100%;
  }
`;
